(() => {
  const popup = document.querySelector("#zengue-surprise-popup");
  const closeButton = document.querySelector("#zengue-surprise-popup-close");
  const frame = document.querySelector("#zengue-surprise-popup-frame");
  const launcher = document.querySelector("#zengue-surprise-launcher");
  if (!popup || !closeButton || !frame || !launcher) return;

  const claimedKey = "zengue-surprise-claimed-v1";
  const dismissedKey = "zengue-surprise-dismissed-v1";
  const dismissFor = 3 * 24 * 60 * 60 * 1000;
  const designMode = Boolean(window.Shopify?.designMode);
  let previouslyFocused = null;

  function storageGet(key) {
    try { return window.localStorage.getItem(key); } catch { return null; }
  }

  function storageSet(key, value) {
    try { window.localStorage.setItem(key, value); } catch {}
  }

  function shouldOpen() {
    if (designMode) return true;
    if (storageGet(claimedKey) === "1") return false;
    const dismissedAt = Number(storageGet(dismissedKey)) || 0;
    return Date.now() - dismissedAt >= dismissFor;
  }

  function isClaimed() {
    return storageGet(claimedKey) === "1";
  }

  function showLauncher() {
    launcher.hidden = isClaimed();
  }

  function openPopup(force = false) {
    if ((!force && !shouldOpen()) || isClaimed()) {
      showLauncher();
      return;
    }
    previouslyFocused = document.activeElement;
    if (!frame.src) frame.src = frame.dataset.src;
    launcher.hidden = true;
    popup.hidden = false;
    popup.setAttribute("aria-hidden", "false");
    document.body.classList.add("zengue-surprise-open");
    window.requestAnimationFrame(() => {
      popup.classList.add("is-visible");
      closeButton.focus({ preventScroll: true });
    });
  }

  function closePopup(remember = true) {
    popup.classList.remove("is-visible");
    popup.setAttribute("aria-hidden", "true");
    document.body.classList.remove("zengue-surprise-open");
    if (remember && !designMode) storageSet(dismissedKey, String(Date.now()));
    window.setTimeout(() => {
      popup.hidden = true;
      previouslyFocused?.focus?.({ preventScroll: true });
      showLauncher();
    }, 260);
  }

  launcher.addEventListener("click", () => openPopup(true));
  closeButton.addEventListener("click", () => closePopup(true));
  popup.addEventListener("click", (event) => {
    if (event.target === popup) closePopup(true);
  });
  document.addEventListener("keydown", (event) => {
    if (event.key === "Escape" && !popup.hidden) closePopup(true);
  });
  window.addEventListener("message", (event) => {
    if (event.origin !== "https://bot.zengue.vip" || event.source !== frame.contentWindow) return;
    if (event.data?.type === "zengue-surprise-claimed") {
      storageSet(claimedKey, "1");
      launcher.hidden = true;
    }
  });

  if (!shouldOpen()) showLauncher();
  window.setTimeout(openPopup, designMode ? 600 : 10_000);
})();
